import axios from 'src/utils/axios';

export const getDefects = ({ kulModelKodu, garantiTipi }) => {
  return axios.get(`/GetArtemisDefects/${kulModelKodu}/${garantiTipi}`);
};

export const getMaterials = ({ kulModelKodu, garantiTipi, hizmetKodu, uyil, udonem }) => {
  return axios.get(`/GetArtemisMaterials/${kulModelKodu}/${garantiTipi}/${hizmetKodu}/${uyil}/${udonem}`);
};

export const getHistoricalMaterials = ({ kulModelKodu, garantiTipi, hizmetKodu, uyil, udonem }) => {
  return axios.get(`/GetArtemisTarihselAgac/${kulModelKodu}/${garantiTipi}/${hizmetKodu}/${uyil}/${udonem}`);
};


export const getLabours = ({ kulModelKodu, garantiTipi, hizmetKodu }) => {
  return axios.get(`/GetArtemisLabours/${kulModelKodu}/${garantiTipi}/${hizmetKodu}`);
};

